import { type ReactElement } from 'react';
import { Info } from 'lucide-react';

/**
 * Tells a non-admin which security group's policies they are looking at
 * (KIR-4334).
 *
 * The member counterpart to the admin-only `PolicyScopeSelector`: a member has
 * no scope to choose, but the group and org views are visually identical, so
 * without this the page still reads as "I see the default policy".
 */
export function MemberScopeNotice({
  groupName,
}: {
  groupName: string;
}): ReactElement {
  return (
    <div
      role="note"
      className="flex items-start gap-2 rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 text-sm text-blue-900 dark:border-blue-900 dark:bg-blue-950 dark:text-blue-100"
    >
      <Info className="mt-0.5 h-4 w-4 shrink-0" />
      <p>
        These policies apply to you through the{' '}
        <span className="font-semibold">{groupName}</span> security group, which
        overrides your organization&apos;s defaults.
      </p>
    </div>
  );
}
